module.exports = __webpack_public_path__ + "static/img/c21.c3d4bfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c21.png
// module id = 267
// module chunks = 0 1 2 3 4 5 6 7 8 9